import {
  getDesignerBusinessCount,
  getOperationDispose,
  getAnalysisSynthesis,
  getContractAmountChart,
  getPercentConversionChart,
  getProcessOrderList,
  getOrderList,
  getAllList,
  getCustomers,
  getOrderStatus,
  getOrderRefundList,
  getVillageList,
  changeStore,
  getStoreList,
  getStaffDetail,
  getMessageList,
  readMessageInfo,
  updateMessageStatus,
  saveRefundAmount,
  getChangeItems,
  saveMeasureInvite,
  getMeasureInvite,
  getFlockproPrietorInfo,
  getMetering,
  getStoreProductPackage,
  getOfferBasics,
  getOrderInfo,
  saveOfferBasics,
  getOfferDetails,
  saveNewMeasureInvite,
  getVillage,
  saveContract,
  getContract,
  saveMetering,
  saveOffer,
  authent,
  buildCode,
  getOrderAmountInfoById,
  sendAmountImage,
  receiptAmount,
  getUploadToken,
  upLoadImage,
  saveDesign,
  getConfideInfo,
  getAmount,
  getUserInfo,
  contract,
  voidContract,
  sendContractDing,
  getContractInfo,
  saveOrderContractResource,
  sendEmail,
  saveConfide,
  getBroadcastDesigner,
  getDiscloseInfo,
  getContractList,
  getRadList,
  getDemandedList,
  getReceivableAmount,
  getCadStatus,
  saveEngineering,
  getStationStaffList,
  customerInfo,
  getSpaceList,
  getMembers,
  getSelectFieldOption,
  getHouseTypeList,
  getCharacterTrend,
  getOfflineChannel,
  getHouseStatusList,
  saveWholeOffer,
  getProductPackageBaseItemPrice,
  getOfferList,
  addShareRecord,
  getProcessList,
  getProcessOrderListV2,
  getConfirmOfferList,
  getMySelectionList,
  getOrderAmountList,
  closeAmount,
  getBaseOrderDetail,
  sendSmsCode,
  getRefundAmountInfo,
  saveApprovalInfo,
  getMaterialsCategory,
  getSubject,
  getMaterialsList,
  getOrderLoseDetails,
  saveInvalid,
  getCustomerList
} from '@/api/designManager.js'

import { setToken, setTokenByKey, getToken } from '@/utils/auth'
import { Notify } from 'vant'
import { login } from '@/api/staff'
const staffDetailKey = 'delivery-staff_detail'

const setStaffDetail = token => setTokenByKey(token, staffDetailKey)

import { SessionStorage } from '@/utils'
import { getStaffRole } from '@/api/delivery'
const session = new SessionStorage()
// const default_token = '369f68f2-700e-4a53-b3d8-047863149961'
// setToken(default_token)

const state = {
  token: getToken(),
  staff_detail: '',
  station_type_id: 2,
  def_staff_role_id: session.get('def_staff_role_id') || '',
  staff_role_list: session.getObject('staff_role_list') || ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_STAFF_DETAIL: (state, staff_detail) => {
    state.staff_detail = staff_detail
    setStaffDetail(JSON.stringify(staff_detail))
  },
  SET_DEF_STAFF_ROLE_ID: (state, staff_role_id) => {
    session.set('def_staff_role_id', staff_role_id)
    state.def_staff_role_id = staff_role_id
  },
  SET_STAFF_ROLE_LIST: (state, staff_role_list) => {
    session.setObject('staff_role_list', staff_role_list)
    state.staff_role_list = staff_role_list
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  setStaffDetail({ state, commit }, staff_detail) {
    commit('SET_TOKEN', staff_detail)
  },
  async login({ state, commit, dispatch }, data) {
    try {
      const res = await login(data)
      const { staff_access_info } = res.data.data
      const token = staff_access_info.token
      dispatch('setToken', token)
      return res.data.data
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  getStaffRole({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffRole(data).then(response => {
        if (response.data.data.staff_role_List.length) {
          commit('SET_STAFF_ROLE_LIST', response.data.data.staff_role_List)
        }
        if (!state.def_staff_role_id && response.data.data.staff_role_List.length) {
          commit('SET_DEF_STAFF_ROLE_ID', response.data.data.staff_role_List[0].staff_role_id)
        }
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDesignerBusinessCount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignerBusinessCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffDetail(data).then(response => {
        commit('SET_STAFF_DETAIL', response.data.data.staff_info)
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 01-获取门店列表
  getStoreList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStoreList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-切换当前门店
  changeStore({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      changeStore(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 12-获取小区
  getVillageList(temp, data) {
    return new Promise((resolve, reject) => {
      getVillageList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOperationDispose({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOperationDispose(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAnalysisSynthesis({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAnalysisSynthesis(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getContractAmountChart({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getContractAmountChart(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPercentConversionChart({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getPercentConversionChart(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getProcessOrderList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getProcessOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAllList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomers({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getCustomers(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 退款单列表
  getOrderRefundList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderRefundList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-01-获取消息列表
  getMessageList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveRefundAmount(temp, data) {
    return new Promise((resolve, reject) => {
      saveRefundAmount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-03-读取消息
  readMessageInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      readMessageInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-05-更新消息为已读状态
  updateMessageStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      updateMessageStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChangeItems(temp, data) {
    return new Promise((resolve, reject) => {
      getChangeItems(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 添加勘测邀请函
  saveMeasureInvite(temp, data) {
    return new Promise((resolve, reject) => {
      saveMeasureInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取勘测邀请函
  getMeasureInvite(temp, data) {
    return new Promise((resolve, reject) => {
      getMeasureInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取群客户信息
  getFlockproPrietorInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getFlockproPrietorInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-05-待勘测订单详情
  getMetering(temp, data) {
    return new Promise((resolve, reject) => {
      getMetering(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单套餐列表
  getStoreProductPackage(temp, data) {
    return new Promise((resolve, reject) => {
      getStoreProductPackage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取报价订单-基础产品包详情
  getOfferBasics(temp, data) {
    return new Promise((resolve, reject) => {
      getOfferBasics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取订单相关基础信息
  getOrderInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 基础报价提交
  saveOfferBasics(temp, data) {
    return new Promise((resolve, reject) => {
      saveOfferBasics(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 精简版报价-02-精简版报价单详情
  getOfferDetails(temp, data) {
    return new Promise((resolve, reject) => {
      getOfferDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 0201-添加勘测邀请函
  saveNewMeasureInvite(temp, data) {
    return new Promise((resolve, reject) => {
      saveNewMeasureInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取小区
  getVillage(temp, data) {
    return new Promise((resolve, reject) => {
      getVillage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建合同提交
  saveContract(temp, data) {
    return new Promise((resolve, reject) => {
      saveContract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取合同签约详情
  getContract(temp, data) {
    return new Promise((resolve, reject) => {
      getContract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-0501-待勘测订单提交
  saveMetering(temp, data) {
    return new Promise((resolve, reject) => {
      saveMetering(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 临时01-报价提交
  saveOffer(temp, data) {
    return new Promise((resolve, reject) => {
      saveOffer(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取实名认证地址
  authent(temp, data) {
    return new Promise((resolve, reject) => {
      authent(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUploadToken({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      if (state.upload_token) {
        resolve(state.upload_token)
        return
      }
      getUploadToken(data).then(response => {
        const uploadToken = response.data.data.uploadToken
        commit('SET_UPLOAD_TOKEN', uploadToken)
        resolve(uploadToken)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取门店包列表
  buildCode(temp, data) {
    return new Promise((resolve, reject) => {
      buildCode(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用支付序号查询支付信息
  getOrderAmountInfoById(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderAmountInfoById(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 发送付款码
  sendAmountImage(temp, data) {
    return new Promise((resolve, reject) => {
      sendAmountImage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 报价单收款
  receiptAmount(temp, data) {
    return new Promise((resolve, reject) => {
      receiptAmount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async upLoadImage({ state, commit, dispatch }, data) {
    try {
      const image_type_key = data.params.jsonText ? JSON.parse(data.params.jsonText).image_type_key : data.params.image_type_key
      const file = data.file
      const uploadToken = await dispatch('getUploadToken')
      const nameArr = file.name.split('.')
      const suffix = nameArr.pop()
      const name = nameArr.join('.') + '-' + (parseInt((new Date().getTime() / 1000)) + '_' + parseInt(Math.random() * 1000))
      const res = await upLoadImage(data.file, {
        token: uploadToken,
        key: image_type_key + '_' + name + '.' + suffix
      })
      return {
        file_info: {
          name: res.data.key,
          url: process.env.VUE_APP_QINIU_URL + '/' + res.data.key
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        commit('SET_UPLOAD_TOKEN', '')
        return await dispatch('upLoadImage', data)
      }
      throw error
    }
  },
  // G-0501-待勘测订单提交
  saveDesign(temp, data) {
    return new Promise((resolve, reject) => {
      saveDesign(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConfideInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConfideInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAmount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAmount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getUserInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  contract({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      contract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  voidContract({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      voidContract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendContractDing({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      sendContractDing(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getContractInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getContractInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveOrderContractResource({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveOrderContractResource(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendEmail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      sendEmail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveConfide({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveConfide(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBroadcastDesigner({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getBroadcastDesigner(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDiscloseInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDiscloseInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getContractList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getContractList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 01-获取方案颜色任务列表
  getRadList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getRadList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // D-02-初步需求档案列表
  getDemandedList(temp, data) {
    return new Promise((resolve, reject) => {
      getDemandedList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // M-获取本次应收金额
  getReceivableAmount(temp, data) {
    return new Promise((resolve, reject) => {
      getReceivableAmount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-1101-cad文件上传状态
  getCadStatus(temp, data) {
    return new Promise((resolve, reject) => {
      getCadStatus(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-11-提交工程部
  saveEngineering(temp, data) {
    return new Promise((resolve, reject) => {
      saveEngineering(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // B-14-获取服务岗位员工列表
  getStationStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getStationStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  customerInfo(temp, data) {
    return new Promise((resolve, reject) => {
      customerInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // H-23-整装报价提交
  saveWholeOffer(temp, data) {
    return new Promise((resolve, reject) => {
      saveWholeOffer(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 27-设计服务空间列表
  getSpaceList(temp, data) {
    return new Promise((resolve, reject) => {
      getSpaceList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMembers(temp, data) {
    return new Promise((resolve, reject) => {
      getMembers(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 27-获取产品包基础项价格
  getProductPackageBaseItemPrice(temp, data) {
    return new Promise((resolve, reject) => {
      getProductPackageBaseItemPrice(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 04-获取选项字段选择下拉列表
  getSelectFieldOption(temp, data) {
    return new Promise((resolve, reject) => {
      getSelectFieldOption(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 09-获取房屋类型
  getHouseTypeList(temp, data) {
    return new Promise((resolve, reject) => {
      getHouseTypeList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCharacterTrend(temp, data) {
    return new Promise((resolve, reject) => {
      getCharacterTrend(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 10-获取房屋状态类型
  getOfflineChannel(temp, data) {
    return new Promise((resolve, reject) => {
      getOfflineChannel(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 10-获取房屋状态类型
  getHouseStatusList(temp, data) {
    return new Promise((resolve, reject) => {
      getHouseStatusList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 带报价订单列表
  getOfferList(temp, data) {
    return new Promise((resolve, reject) => {
      getOfferList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 设计师分享服务手册
  addShareRecord(temp, data) {
    return new Promise((resolve, reject) => {
      addShareRecord(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // B-01-获取订单节点流程列表
  getProcessList(temp, data) {
    return new Promise((resolve, reject) => {
      getProcessList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // B-02-流程订单列表
  getProcessOrderListV2(temp, data) {
    return new Promise((resolve, reject) => {
      getProcessOrderListV2(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // H-22-获取已确定报价列表
  getConfirmOfferList(temp, data) {
    return new Promise((resolve, reject) => {
      getConfirmOfferList(data).then(response => {
        const data = response.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 选材主页-选材确认提交
  getMySelectionList(temp, data) {
    return new Promise((resolve, reject) => {
      getMySelectionList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 16-预上门客户未到店
  getOrderAmountList(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderAmountList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 选材主页-获取材料分类
  getMaterialsCategory(temp, data) {
    return new Promise((resolve, reject) => {
      getMaterialsCategory(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // M-关闭收款单
  closeAmount(temp, data) {
    return new Promise((resolve, reject) => {
      closeAmount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-9001-订单详情-基本信息
  getBaseOrderDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getBaseOrderDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 28-发送验证码
  sendSmsCode(temp, data) {
    return new Promise((resolve, reject) => {
      sendSmsCode(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-获取退款单详情
  getRefundAmountInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getRefundAmountInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 选材单主页
  getSubject(temp, data) {
    return new Promise((resolve, reject) => {
      getSubject(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 2-发起审批
  saveApprovalInfo({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      saveApprovalInfo(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 选材主页-获取分类材料列表
  getMaterialsList(temp, data) {
    return new Promise((resolve, reject) => {
      getMaterialsList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单输单详情
  getOrderLoseDetails(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderLoseDetails(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 输单提交
  saveInvalid(temp, data) {
    return new Promise((resolve, reject) => {
      saveInvalid(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 01-待接收用户
  getCustomerList(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerList(data).then(response => {
        const data = response.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
